import { useQuery } from '@tanstack/react-query';
import DropdownStyled from '@/src/app/components/inputs/StyledInputs/DropdownStyled';
import {
  SubcontractCOFormItem,
  UnitOfMeasure,
} from '@/src/app/Interfaces/Accounting/ACForms.interfaces';
import { fetchUnitsOfMeasure } from '@/src/app/services/accounting/ACFormsService';
import React from 'react';

type UMProps = {
  item: SubcontractCOFormItem;
  updateItems?: (item: SubcontractCOFormItem) => void;
  fetchData: boolean;
  textMode?: boolean;
  showError?: boolean;
  disabled?: boolean;
};

const UM = ({
  item,
  updateItems,
  fetchData,
  textMode = false,
  showError,
  disabled,
}: UMProps) => {
  const hasError = showError && !item.um;

  const umRequest = useQuery({
    queryKey: ['getUnitOfMeasure'],
    queryFn: ({ signal }) => {
      return fetchUnitsOfMeasure(signal);
    },
    refetchOnWindowFocus: false,
    enabled: fetchData,
  });
  const um = umRequest.data?.find((um: UnitOfMeasure) => um.UM === item.um);

  return (
    <React.Fragment>
      {!textMode && (
        <DropdownStyled
          value={item.um}
          options={umRequest.data?.filter(
            (um: UnitOfMeasure) => um.UM !== 'MOS' && um.UM !== 'QTR'
          )}
          labelField="Description"
          valueField="UM"
          placeholder={
            umRequest.isError ? 'Failed to load options' : 'Select Option'
          }
          isDisabled={!item.isNew || umRequest.isError || disabled}
          isLoading={umRequest.isFetching}
          clearable={false}
          filter={true}
          resetFilterOnHide={true}
          onChange={(e) => {
            item.um = e.value;
            if (e.value === 'LS') {
              item.units = 0;
              item.unitCosts = 0;
            }

            if (updateItems) updateItems(item);
          }}
          className={`${hasError && 'p-invalid'} printHide`}
        />
      )}
      <span className={textMode ? undefined : `printMedia printShow`}>
        {um?.Description}
      </span>
    </React.Fragment>
  );
};

export default UM;
